/* eslint-disable comma-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */

import Dropdown from '@cashew/dropdown';
import { api } from '@cashew/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

export default ({ showAllOption }: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [storeList, setStoreList] = useState<Array<any>>([]);
  const [selectedStoreDropDown, setSelectedStoreDropDown] = useState('0');
  const [storeDropDown, setStoreDropDown] = useState([]);
  const { principalId, token, storeName, selectedStore } = useSelector(
    (state: any) => state.user
  );

  const dispatchDefaultStore = () => {
    dispatch({
      type: 'SELECT_STORE',
      payload: {
        selectedStore: '0',
        storeName: 'All',
      },
    });
  };

  useEffect(() => {
    api
      .get({
        endpoint: 'stores',
        headers: {
          Authorization: token,
        },
      })
      .then((resp: any) => {
        const listStores = resp.data.map((item: any) => ({
          key: item.id,
          value: item.storeName,
        }));

        listStores.sort((firstElement: any, secondElement: any) => {
          const firstElementValue = firstElement.value.toUpperCase();
          const secondElementValue = secondElement.value.toUpperCase();
          // eslint-disable-next-line no-nested-ternary
          return firstElementValue === secondElementValue
            ? 0
            : firstElementValue > secondElementValue
              ? 1
              : -1;
        });

        setStoreDropDown(listStores);
        setStoreList(resp.data);
        setSelectedStoreDropDown(selectedStore);

        if (!storeName) {
          dispatchDefaultStore();
        }
      })
      .catch((resp) => api.errorHandler({ resp, history, dispatch }));
  }, [principalId, storeName]);

  useEffect(() => {
    if (storeDropDown.length) {
      // @ts-ignore
      if (selectedStoreDropDown > 0) {
        const activeStore: any = storeDropDown.find(
          ({ key }) => key === selectedStoreDropDown
        );
        if (Object.prototype.hasOwnProperty.call(activeStore, 'key')) {
          dispatch({
            type: 'SELECT_STORE',
            payload: {
              selectedStore: activeStore.key,
              storeName: activeStore.value,
            },
          });
        } else {
          dispatchDefaultStore();
        }
      } else {
        dispatchDefaultStore();
      }
    }
  }, [selectedStoreDropDown]);

  const oneItem = storeDropDown.map((item: object) => ({
    ...item,
    key: '0',
  })) as never[];

  return (
    <>
      {storeList.length > 0 && (
        <Dropdown
          label=""
          data={
            showAllOption && storeList.length > 1
              ? [{ key: '0', value: 'All' }, ...storeDropDown]
              : oneItem
          }
          selected={selectedStoreDropDown}
          onSelect={setSelectedStoreDropDown}
        />
      )}
    </>
  );
};
